import { forwardRef } from 'react'
import { useFormContext } from 'react-hook-form'

const ShowroomSelect = forwardRef(({ name, placeholder, required, ...rest }, ref) => {
  const { setValue } = useFormContext()

  const handleChange = (e) => {
    setValue(name, e.target.value)
  }

  return (
    <select {...rest} onChange={handleChange} name={name} ref={ref} placeholder="Showroom">
      <option value=''>{placeholder}</option>
      <option key='showroom-sydney' value='Sydney'>Sydney Showroom</option>
      <option key='showroom-melbourne' value='Melbourne'>Melbourne Showroom</option>
      <option key='showroom-brisbane' value='Brisbane'>Brisbane Showroom</option>
    </select>
  )
})

export default ShowroomSelect
